module.exports = __webpack_public_path__ + "static/media/faq.a7a9652b.mp3";